exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-top[data-v-52fcc116]{margin-left:20px;margin-bottom:-5px;margin-top:10px}.button-first[data-v-52fcc116]{margin-left:10px}.el-container[data-v-52fcc116]{margin-top:-20px;width:500px}.app-container[data-v-52fcc116]{width:100%}.el-header[data-v-52fcc116]{color:#909399;font-size:larger;line-height:100px;margin-left:5px;width:100%}.el-form-item[data-v-52fcc116]{color:lightgrey}.el-button[data-v-52fcc116]{position:center}.background[data-v-52fcc116]{padding-top:14px}.space[data-v-52fcc116]{margin-bottom:4px}\n", ""]);

// exports
